import Devise from "@kaspernj/api-maker/build/devise"
import {User} from "models"

const select = {
  User: [
    "contactId",
    "createdAt",
    "currentCountryId",
    "email",
    "firstName",
    "id",
    "identifiedRoles",
    "lastName",
    "name",
    "unconfirmedEmail"
  ]
}

export {select}
export default async function usersUpdateSession(userId) {
  if (userId) {
    const currentUserWithRelationships = await User
      .ransack({id_eq: userId})
      .preload(["contact.parent_relationships.contact_relationship_type", "user_roles.role"])
      .select(select)
      .first()

    Devise.updateSession(currentUserWithRelationships, {scope: "user"})
    Devise.events().emit("onDeviseSignIn")
  } else {
    Devise.updateSession(null, {scope: "user"})
    Devise.events().emit("onDeviseSignOut")
  }
}
